var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1285 0C20.3595 0 20.566 0.0857143 20.748 0.257143C20.916 0.421714 21 0.620571 21 0.853714V17.1463C21 17.3794 20.916 17.5783 20.748 17.7429C20.566 17.9143 20.3595 18 20.1285 18H6.1215C5.8905 18 5.684 17.9143 5.502 17.7429C5.334 17.5783 5.25 17.3794 5.25 17.1463V14.1429H0.8715C0.6405 14.1429 0.434 14.0606 0.252 13.896C0.084 13.7177 0 13.5154 0 13.2891V4.71086C0 4.48457 0.084 4.28229 0.252 4.104C0.434 3.93943 0.6405 3.85714 0.8715 3.85714H5.25V0.853714C5.25 0.620571 5.334 0.421714 5.502 0.257143C5.684 0.0857143 5.8905 0 6.1215 0M5.25 10.0903L6.489 12.3737H8.3685L6.3 9.06172L8.3265 5.80114H6.531L5.3865 7.86857L5.3445 7.93029L5.313 8.00229C5.131 7.63886 4.935 7.272 4.725 6.90172C4.55 6.53829 4.3645 6.17143 4.1685 5.80114H2.268L4.2525 9.08229L2.1 12.3737H3.969M12.474 16.7143V14.1429H6.5625V16.7143M12.474 12.8571V9.648H10.5V12.8571M12.474 8.36229V5.14286H10.5V8.36229M12.474 3.85714V1.28571H6.5625V3.85714M19.6875 16.7143V14.1429H13.7865V16.7143M19.6875 12.8571V9.648H13.7865V12.8571M19.6875 8.36229V5.14286H13.7865V8.36229M19.6875 3.85714V1.28571H13.7865V3.85714H19.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.354e62fb6ed53cad42630447c60985a2.svg";
export { ForwardRef as ReactComponent };